export const trackEvent = (interactionData) => {
	if (window.DDC && window.DDC.fireTrackingEvent) {
		const defaultData = {
			event: 'thirdPartyUserEvent',
			product: 'My Wallet Syndication',
			step: 'Any My Wallet Step',
			noninteraction: false
		}

		window.DDC.fireTrackingEvent({
			...defaultData,
			...interactionData
		});
	}
}

const destructureEventName = (eventNameFromAccelerate) => {
	const eventNameArray = eventNameFromAccelerate.toLowerCase().split('_').slice(1);
	return {
		action: eventNameArray.pop(),
		element: eventNameArray.map(item => item.charAt(0).toUpperCase() + item.slice(1)).join(' ') || undefined
	}
};

export const trackWidgetUserEvent = (element, action, data, eventName) => {
	if (typeof jQuery !== 'undefined') {
		jQuery(document).trigger('trackEvent', {
			event: 'widgetUserEvent',
			widgetName: 'digital-retailing-cox',
			widgetId: 'digital-retailing1',
			element,
			action,
			elementCTA: undefined,
			result: undefined,
			widgetState: data?.dealType,
			fieldValue: undefined,
			formId: undefined,
			formEventId: undefined,
			value: undefined,
			sourceData: data,
			eventName
		});
	}
};

const trackTraditionalEvent = (element, action) => {
	if (typeof jQuery !== 'undefined') {
		jQuery(document).trigger('trackEvent', {
			widgetName: 'mywallet-integration',
			eventName: action,
			data: element
		});
	}
};

export const trackCADREvent = (eventName, eventData) => {
	const { action, element } = destructureEventName(eventName);

	trackWidgetUserEvent(element, action, eventData, eventName);
	trackTraditionalEvent(element, action);

	return true;
};
